import { StatesClasses } from './grid.constants';

export function createCategoryTagStatesMap<T extends string>(
  categories: T[],
): Record<string, string> {
  return Object.fromEntries(
    categories.map((category) => [category, StatesClasses.MistyStone]),
  );
}
